//@ts-check
import { myxchngApiClient } from '../../utils/RequestClient';
import RequestSearchParams from '../../utils/RequestSearchParams';

/** @type {Record<import('@action-types/ecVersion').AcceptHeaderKeys, string>} */
const acceptHeaderMap = Object.freeze({
  card: 'application/vnd.adobe.xt.app-card-v1+json',
  details: 'application/vnd.adobe.xt.app-detail-v2+json',
});

/**
 * @param {object} params
 * @param {import('@action-types/ecVersion').AppPayload[]} [params.appVersionList]
 * @param {string} [params.token]
 * @param {keyof typeof acceptHeaderMap} [params.type]
 * @param {AbortSignal} [params.signal]
 * @param {number | string} [params.pageSize]
 * @param {number | string} [params.pageIndex]
 * @returns {Promise<import('@action-types/ecVersion').SearchEcVersionsResponse>}
 * @throws {import('@action-types/RequestError').RequestError<import('@action-types/ecApp').MyxchngApiErrorResponse>}
 */
const searchEcVersions = async ({ signal, appVersionList, pageIndex, token, type = 'card', ...params }) => {
  const pageSize = params.pageSize || appVersionList?.length;
  const searchParams = new RequestSearchParams({ pageSize, pageIndex });
  const headers = new Headers({ accept: acceptHeaderMap[type] });
  if (token) {
    headers.set('authorization', `Bearer ${token}`);
  }
  const { jsonResponse } = await myxchngApiClient.fetch({
    endpoint: `/v2/versions/search${searchParams}`,
    requestOptions: {
      method: 'POST',
      signal,
      headers,
      body: JSON.stringify({ appVersionList }),
    },
  });

  return jsonResponse;
};

export default searchEcVersions;
